const setCookie = window.BAO.Utils.setCookie
const getCookie = window.BAO.Utils.getCookie

class ModalNewsletter extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  constructor () {
    super()

    this.onTrigger = this.onTrigger.bind(this)
    this.onClose = this.onClose.bind(this)
    this.handleSuccess = this.handleSuccess.bind(this)
    this.onSwitchView = this.onSwitchView.bind(this)
    this.onFormSubmit = this.onFormSubmit.bind(this)
    this.resetSignUpSource = this.resetSignUpSource.bind(this)
    this.onPointerDown = this.onPointerDown.bind(this)
    this.onBackdropClick = this.onBackdropClick.bind(this)

    this.pointerDownTarget = null

    this.timeDelay = Number(this.dataset.closeDelay) * 1000 || 3000

    this.cookies = {
      PAGE_COUNTER: this.dataset.cookieName,
      MODAL_SHOWN: 'newsletter_modal_shown',
    }

    this.originalSource = ''
    this.autoShow = this.dataset.autoShow === 'true'
    this.autoSource = this.dataset.autoSource
    this.pageCount = Number(this.dataset.pageCount)
    this.cookies.PAGE_COUNTER = this.dataset.cookieName
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.autoShow && this.pageCount) {
      this.handleAutoShow()
    }
  }

  setupListeners () {
    super.setupListeners()

    this.externalEls?.trigger?.elements.forEach((trigger) => {
      this.listeners.add(trigger, 'click', this.onTrigger)
    })

    this.els?.close?.elements.forEach((closeEl) => {
      this.listeners.add(closeEl, 'click', this.onClose)
    })

    this.listeners.add(this.els['form-trigger']?.element, 'click', () =>
      this.onSwitchView(true),
    )

    this.listeners.add(this.els?.form?.element, 'submit', this.onFormSubmit)

    this.listeners.add(this, 'cancel', this.resetSignUpSource)

    this.listeners.add(this, 'pointerdown', this.onPointerDown)
    this.listeners.add(this, 'click', this.onBackdropClick)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.NEWSLETTER_FORM.SUCCESS,
      this.handleSuccess,
    )
  }

  pageHasRefreshed () {
    return sessionStorage.getItem('previousUrl') === window.location.pathname
  }

  setPreviousUrl () {
    sessionStorage.setItem('previousUrl', window.location.pathname)
  }

  incrementPageCount () {
    const currentCount = this.getCurrentPageCount()
    if (currentCount >= this.pageCount) return

    const config = { name: this.cookies.PAGE_COUNTER, value: currentCount + 1 }

    setCookie(config)
  }

  getCurrentPageCount () {
    return Number(getCookie(this.cookies.PAGE_COUNTER)) || 0
  }

  modalDismissed () {
    return getCookie(this.cookies.MODAL_SHOWN) === 1
  }

  belowPageCountThreshold () {
    return this.getCurrentPageCount() < this.pageCount
  }

  registerModalAutoShown () {
    setCookie({ name: this.cookies.MODAL_SHOWN })
  }

  setSignUpSource () {
    const inputEl = this.els.signupsource?.element

    if (!(inputEl && this.autoSource)) return

    this.originalSource = inputEl.value
    inputEl.value = this.autoSource
  }

  resetSignUpSource () {
    const inputEl = this.els.signupsource?.element

    if (inputEl && this.originalSource) {
      inputEl.value = this.originalSource
    }
  }

  handleAutoShow () {
    // Check for page refreshes and ignore everything including page count increments
    if (this.pageHasRefreshed()) {
      return
    }

    // Check if the modal has been shown previously
    if (this.modalDismissed()) return

    // Increment the counter and set the new URL
    this.setPreviousUrl()
    this.incrementPageCount()

    // Get the current page count from the cookie and check if we have reached the count threshold
    if (this.belowPageCountThreshold()) return

    if (this.autoSource) {
      this.setSignUpSource()
    }

    // if the page count has been reached show the modal and set the shown cookie
    this.showModal()
    this.registerModalAutoShown()
  }

  onTrigger () {
    this.showModal()
  }

  onClose () {
    this.close()
    this.onSwitchView(false)
    this.resetSignUpSource()
  }

  handleSuccess () {
    this.addEventListener('transitionend', this.onCloseTransitionEnd, {
      once: true,
    })

    window.setTimeout(() => {
      this.classList.add('mod-Modal-newsletterClosing')
    }, this.timeDelay)
  }

  onCloseTransitionEnd (event) {
    this.removeEventListener('transitionend', this.onCloseTransitionEnd, {
      once: true,
    })
    if (event.propertyName === 'transform') {
      this.onClose()
      this.classList.remove('mod-Modal-newsletterClosing')
    }
  }

  onPointerDown (event) {
    this.pointerDownTarget = event.target
  }

  onBackdropClick (event) {
    const isBackdrop = event.target === this && this.pointerDownTarget === this
    this.pointerDownTarget = null

    if (isBackdrop) this.onClose()
  }

  onSwitchView (showForm) {
    this.els?.content?.element.setAttribute('aria-hidden', showForm)
    this.els['form-container']?.element.setAttribute('aria-hidden', !showForm)
  }

  onFormSubmit (event) {
    this.els?.text.element.setAttribute('aria-hidden', true)
  }
}

if (!customElements.get('modal-newsletter')) {
  customElements.define('modal-newsletter', ModalNewsletter, {
    extends: 'dialog',
  })
}
